var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wbg"},[_c('a-tree',{attrs:{"checkable":"","expanded-keys":_vm.expandedKeys,"auto-expand-parent":_vm.autoExpandParent,"tree-data":_vm.treeData},on:{"expand":_vm.onExpand},model:{value:(_vm.checkedKeys),callback:function ($$v) {_vm.checkedKeys=$$v},expression:"checkedKeys"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }